import { ColumnDef } from '@tanstack/react-table';
import i18n from 'i18next';

import { TableData } from '@/types';

export const getCeremonyTemplateColumns: (allowedPermission: boolean) => ColumnDef<TableData>[] = (
  allowedPermission: boolean
) => {
  const defaultColumns: ColumnDef<TableData>[] = [
    {
      id: 'name',
      accessorKey: 'name',
      header: i18n.t('name', { ns: 'common' })
    },
    {
      id: 'noOfSlots',
      accessorKey: 'noOfSlots',
      header: i18n.t('noOfSlots', { ns: 'common' })
    }
  ];

  if (allowedPermission) {
    defaultColumns.push({
      id: 'organization',
      accessorKey: 'organization',
      header: i18n.t('organization', { ns: 'common' }),
      cell: (props) => {
        return (
          <div className='flex justify-end md:justify-start'>{props.getValue() as string}</div>
        );
      }
    });
  }

  return defaultColumns;
};
